import {createRouter, createWebHistory} from 'vue-router'

const routes = [
  {
    path: "/preview/clanok/:token",
    name: "ContentPostPreview",
    component: () => import("../components/public/ContentPostPreview.vue")
  },
  {
    path: "/public/",
    name: "LegacyPublicView",
    component: () => import("../views/PublicView.vue"),
    children: [
      {
        path: "inzerat/dom/:id",
        name: "LegacyAdDetailView",
        component: () => import("../containers/public/AdDetailView.vue")
      }
    ],
  },
  {
    path: "/p/",
    name: "PublicView",
    component: () => import("../views/PublicView.vue"),
    children: [
      {
        path: "",
        name: "HomeView",
        component: () => import("../containers/public/HomeView.vue")
      },
      {
        path: "inzerat/:id",
        alias: ["/dom/:id", "/byt/:id", "/pozemok/:id", "/priestor/:id"],
        name: "AdDetailView",
        component: () => import("../containers/public/AdDetailView.vue")
      },
      {
        path: "inzerat/:id/fotky",
        alias: ["/dom/:id/fotky", "/byt/:id/fotky", "/pozemok/:id/fotky", "/priestor/:id/fotky"],
        name: "AdGalleryView",
        component: () => import("../containers/public/AdGalleryView.vue")
      },
      {
        path: "inzerat/:id/podklady",
        alias: ["/dom/:id/podklady", "/byt/:id/podklady", "/pozemok/:id/podklady", "/priestor/:id/podklady"],
        name: "AdDocumentsView",
        component: () => import("../containers/public/AdDocumentsView.vue")
      },
      {
        path: "projekty/",
        name: "ActiveProjectsView",
        component: () => import("../containers/public/ActiveProjectsView.vue")
      },
      {
        path: "projekty/:slug",
        name: "ProjectReferenceView",
        component: () => import("../containers/public/ProjectReferenceView.vue")
      },
      {
        path: "inzeraty/",
        name: "AdsView",
        component: () => import("../containers/public/AdsView.vue")
      },
      {
        path: "o-nas/",
        name: "AboutUsView",
        component: () => import("../containers/public/AboutUsView.vue")
      },
      {
        path: "zo-zivota-urbo/",
        name: "LifeAtUrboView",
        component: () => import("../containers/public/LifeAtUrboView.vue")
      },
      {
        path: "blog/r1-most-pri-bratislave-vlckovce-senec-novy-svet",
        name: "BlogPost14",
        component: () => import("../containers/public/BlogView.vue")
      },
      {
        path: "blog/:id",
        name: "BlogView",
        component: () => import("../containers/public/BlogView.vue")
      },
      {
        path: "blog/leto-na-stavbe-theupside-jul-august-2026",
        name: "BlogPost13",
        component: () => import("../containers/public/BlogView.vue")
      },
      // BlogPost1
      {
        path: "blog/zacali-sme-murovat",
        name: "BlogPost1",
        component: () => import("../components/public/blogs/BlogPost1.vue")
      },
      // BlogPost2
      {
        path: "blog/start-vystavby-a-vykopy",
        name: "BlogPost2",
        component: () => import("../components/public/blogs/BlogPost2.vue")
      },
      // BlogPost3
      {
        path: "blog/murujeme-2np-okna-strechy-fasady",
        name: "BlogPost3",
        component: () => import("../components/public/blogs/BlogPost3.vue")
      },
      // BlogPost4
      {
        path: "blog/den-deti-novy-svet-theupside",
        name: "BlogPost4",
        component: () => import("../components/public/blogs/BlogPost4.vue")
      },
      // BlogPost5
      {
        path: "blog/prelette-sa-po-stavenisku-theupside",
        name: "BlogPost5",
        component: () => import("../components/public/blogs/BlogPost5.vue")
      },
      // BlogPost6
      {
        path: "blog/osadzame-vazniky-strechy-theupside",
        name: "BlogPost6",
        component: () => import("../components/public/blogs/BlogPost6.vue")
      },
      // BlogPost7
      {
        path: "blog/pokladka-hydroizolacnej-folie-bauder-theupside",
        name: "BlogPost7",
        component: () => import("../components/public/blogs/BlogPost7.vue")
      },
      // BlogPost8
      {
        path: "blog/ozivujeme-interiery-theupside-inteligentne-rozvody",
        name: "BlogPost8",
        component: () => import("../components/public/blogs/BlogPost8.vue")
      },
      // BlogPost9
      {
        path: "blog/tepelne-cerpadlo-vitocal-200-a-theupside",
        name: "BlogPost9",
        component: () => import("../components/public/blogs/BlogPost9.vue")
      },
      // BlogPost10
      {
        path: "blog/vence-vazniky-domy-302-304-theupside",
        name: "BlogPost10",
        component: () => import("../components/public/blogs/BlogPost10.vue")
      },
      // BlogPost11
      {
        path: "blog/podpora-cov-novy-svet-theupside",
        name: "BlogPost11",
        component: () => import("../components/public/blogs/BlogPost11.vue")
      }
    ],
  },
  // {
  //   path: "/auth/login/",
  //   name: "Login",
  //   component: () => import("../containers/app/auth/Login.vue"),
  // },
  // {
  //   path: "/app/",
  //   name: "AppView",
  //   component: () => import("../views/AppView.vue"),
  //   children: []
  // },

  {
    path: '/:catchAll(.*)',
    redirect: '/p/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }

    return { top: 0 };
  },
})

export default router
